import { createSelector } from 'reselect';

import { isAdvicePending } from 'works/utils';
import { ADVICE_STATUS, CHECKLIST_TYPE } from 'modules/entity/constants';

import { getRoot } from '../general';
import { getAdviceIdsByType, getAdvicesByIds, getOfferedAdvices } from '.';

const getPartsAdvicesIds = createSelector(getAdviceIdsByType, (ids) => ids[CHECKLIST_TYPE.PARTS] ?? []);

const getPartsReminderScheduledIds = createSelector(
  getAdviceIdsByType,
  (ids) => ids[CHECKLIST_TYPE.PARTS_REMINDER_SCHEDULED] ?? []
);

const getAllPartsAdvices = createSelector(
  getPartsAdvicesIds,
  getPartsReminderScheduledIds,
  (partsAdvices, partsReminderAdvices) => [...partsAdvices, ...partsReminderAdvices]
);

const getPartsAdvices = createSelector(getRoot, getAllPartsAdvices, getAdvicesByIds);

export const hasParts = createSelector(
  getPartsAdvicesIds,
  getPartsReminderScheduledIds,
  (partsAdvices, partsReminderAdvices) => [...partsAdvices, ...partsReminderAdvices].length > 0
);

const getAnsweredAdvices = createSelector(getPartsAdvices, (advices) =>
  advices.filter(({ status }) => status !== ADVICE_STATUS.PENDING));

export const getAnsweredAdvicesIds = createSelector(getAnsweredAdvices, (advices) =>
  advices.map(({ adviceId }) => adviceId));

export const hasAnsweredAdvices = createSelector(getAnsweredAdvicesIds, (ids) => ids.length > 0);

const getPendingPartsAdvices = createSelector(getPartsAdvices, (advices) => advices.filter(isAdvicePending));

const getPendingPartsAdvicesIds = createSelector(getPendingPartsAdvices, (advices) =>
  advices.map(({ adviceId }) => adviceId));

const getPendingOfferedAdvices = createSelector(getOfferedAdvices, (advices) => advices.filter(isAdvicePending));

const getPendingOfferedAdvicesIds = createSelector(getPendingOfferedAdvices, (advices) =>
  advices.map(({ adviceId }) => adviceId));

export const getPendingAdvicesIds = createSelector(
  getPendingPartsAdvicesIds,
  getPendingOfferedAdvicesIds,
  (pendingIds, offeredIds) => [...pendingIds, ...offeredIds]
);

export const hasPendingAdvices = createSelector(getPendingAdvicesIds, (adviceIds) => adviceIds.length > 0);
